import * as React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

export const MessagesSelected = (props: SvgProps) => {
  return (
    <Svg width='25' height='25' viewBox='0 0 25 25' fill='none' {...props}>
      <Path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.16998 0C2.61465 0 1.31725 1.18865 1.18144 2.73803L0.0116877 16.0827C-0.14202 17.8362 1.23999 19.3446 3.00023 19.3446H8.41537L10.2574 22.5964C11.7767 25.2783 15.8677 24.2 15.8677 21.1177V19.3446H19.8691C21.4244 19.3446 22.7218 18.156 22.8576 16.6066L24.0273 3.26197C24.1811 1.50845 22.799 0 21.0388 0H4.16998Z'
        fill='currentColor'
      />
    </Svg>
  )
}
